import React, { createContext, FunctionComponent } from 'react';
import { noop } from 'lodash';
import { useRecoilState } from 'recoil';
import { mapTypeState } from '../recoil/atoms';

export type MapTypes = 'light' | 'dark' | 'satellite' | 'streets' | 'satellite-hybrid' | 'nearmaps';

export const MapStyleContext = createContext<{
  mapStyle: string;
  setMapType: (style: MapTypes) => void;
  mapType: string;
}>({
  mapStyle: 'mapbox://styles/mapbox/satellite-streets-v11',
  setMapType: noop,
  mapType: 'satellite-hybrid',
});

export const MapStyleProvider: FunctionComponent<{
  children?: React.ReactNode;
}> = (props) => {
  const [mapType, setMapType] = useRecoilState(mapTypeState);

  const mapStyle = React.useMemo(() => {
    switch (mapType) {
      case 'dark':
        return `mapbox://styles/mapbox/dark-v10`;
      case 'light':
        return `mapbox://styles/mapbox/light-v10`;
      case 'satellite':
        return `mapbox://styles/mapbox/satellite-v9`;
      case 'satellite-hybrid':
        return `mapbox://styles/mapbox/satellite-streets-v11`;
      case 'streets':
        return `mapbox://styles/mapbox/streets-v11`;
      case 'nearmaps':
        return `mapbox://styles/mapbox/satellite-v9`;
      default:
        return `mapbox://styles/mapbox/satellite-streets-v11`;
    }
  }, [mapType]);

  return (
    <MapStyleContext.Provider value={{ mapStyle, setMapType, mapType }}>{props.children}</MapStyleContext.Provider>
  );
};
